import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import en from './locales/en.json';
import ptBR from './locales/pt-BR.json';
import ptPT from './locales/pt-PT.json';
import es from './locales/es.json';

// Translation resources
const resources = {
  en: { translation: en },
  'pt-BR': { translation: ptBR },
  'pt-PT': { translation: ptPT },
  es: { translation: es }
};

// Clear old localStorage entries that might be causing issues
if (typeof window !== 'undefined') {
  localStorage.removeItem('i18nextLng');
  localStorage.setItem('i18nextLng', 'pt-PT');
}

// Language configuration
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English (UK)', flag: '🇬🇧' },
  { code: 'pt-BR', name: 'Português (Brasil)', flag: '🇧🇷' },
  { code: 'pt-PT', name: 'Português (Portugal)', flag: '🇵🇹' },
  { code: 'es', name: 'Español (España)', flag: '🇪🇸' }
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'pt-PT', // Force Portuguese (Portugal) as default language
    fallbackLng: 'pt-PT', // Also use pt-PT as fallback
    debug: true, // Always enable debug for now
    
    detection: {
      order: ['localStorage', 'htmlTag', 'navigator'],
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false // React already escapes values
    },

    react: {
      useSuspense: true // Enable React Suspense mode
    },

    // Wait for translations to be loaded before rendering components
    initImmediate: false,
    
    // Add keySeparator and nsSeparator for nested keys
    keySeparator: '.',
    nsSeparator: false
  });

export default i18n;